import Footer from "./Footer";
import LandHeader from "./LandHeader";
import { Link } from "react-router-dom";
import {useMediaQuery} from "beautiful-react-hooks";
import { useEffect, useState ,useRef  } from "react";
import axios from "axios";
import { MdContentCopy } from "react-icons/md";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import SimpleAccordion from "./SimpleAccordion";
import TabType from "./TabType"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import PaginatedItems from "./PaginatedItems";
import PageItemsAcc from "./PageItemsAcc";
import LoadingAcc from "./LoadingAcc";
import LoadingTable from "./LoadingTable";
import {useNavigate, useLocation} from "react-router-dom";
import SliderTypes from "./SliderTypes";

const data = [
    {
        "queOne":"رمز ارز دیجیتال بازی (Game) با لیست کامل ",
        "ansOne":"در دنیای مدرن، جایی که فناوری و سرگرمی به طور مداوم با هم ترکیب می‌شوند، رمز ارز دیجیتال بازی به عنوان یک نوآوری قدرتمند ظهور کرده است. این ارزهای دیجیتال، که اغلب به عنوان   GameFiشناخته می‌شوند، نه تنها روش‌های پرداخت در دنیای بازی‌ها را متحول کرده‌اند، بلکه به بازیکنان امکان می‌دهند تا از طریق مشارکت فعال در اکوسیستم‌های بازی، درآمد کسب کنند.رمز ارز بازی ریشه در مفهوم پول درون بازی دارد که سال‌هاست در صنعت بازی‌های ویدئویی مورد استفاده قرار می‌گیرد. با این حال، با ظهور بلاکچین و فناوری‌های مرتبط، این ارزها از محدودیت‌های سیستم‌های مالی سنتی فراتر رفته و به ابزارهایی با قابلیت تبادل و ارزش واقعی تبدیل شده‌اند."
    },
    {
        "queOne":"ارزهای بازی معروفیت در دنیای مالی دیجیتال دارند؟",
        "ansOne":"بله، ارزهایی مانند Ethereum-based ERC-20 tokens، Decentraland (MANA) و Enjin Coin (ENJ) از جمله معروف‌ترین ارزهای بازی هستند."
    },
    {
        "queOne":"آیا ارزهای بازی ارزش سرمایه‌گذاری دارند؟",
        "ansOne":"بله، ارزهای بازی می‌توانند ارزش سرمایه‌گذاری داشته باشند، اما باید به مواردی مانند بازار واقعیت مجازی، استفاده‌پذیری و روند توسعه آن‌ها توجه کنید."
    },
   
]





export default function Games(){
    const elementRef = useRef(null);

    const isSmall = useMediaQuery('(max-width: 768px)')

    const[Auth,setAuth] = useState(false) 
    const [isCopied, setIsCopied] = useState(false);

    const[inviteLink,setInviteLink] = useState('')

    const [symbol,setSymbol] = useState([])
    const [resultSym,setResultSym] = useState([])
    const [search,setSearch] = useState()

    const navigate = useNavigate();

    const [TeterPriceBuy,setTeterPriceBuy] = useState()
    const [TeterPriceSell,setTeterPriceSell] = useState()
    const [isAll,setIsAll] = useState(false)
    const [isLoading,setIsLoading] = useState(true)
    const [loadButton ,setLoadButton] = useState(false)
    const [result,setResult] = useState([])
    const [tabChange,setTabChange] = useState(false)
    const [key,setKey] = useState(0)
    const [notFound,setNotFound] = useState(false)
    const [Phone,setPhone] = useState("")
    const [error,seterror] = useState('')
    const [loadingp,setLoadingp] = useState(false)



    function hanldleSearch(event) {
        setSearch(event.target.value)

    }



    const scrollToElement = () => {
        if (elementRef.current) {
          elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };



      useEffect(()=>{
        const results = symbol.filter(({symbol,persionName}) => {
               return(
                   persionName.includes(search))
                 ||
                   symbol.includes(search.toUpperCase())
           });
     
           if (search){
             if(results.length === 0){
             }else {
      
             }
         }
     
           setResultSym(results)
         },[search])

    

    function GoToLogin(){
        navigate('/login')
    }

    
    function handleTabs(value) {
        let k = Math.random()

        console.log(value)

        let lidata = symbol

        console.log(lidata)


        if (value === 1) {
            const res = lidata.sort(function (a, b) {
                return b.changeRate - a.changeRate
            }) 
            setResult(res)
           setTabChange(true)
                       setKey(k)


           }
        else if (value === 2) {
            const res = lidata.sort(function (a, b) {
                return b.volValue - a.volValue
            }) 
            setResult(res)
           setTabChange(true)
                       setKey(k)



        }
           

           


         else if (value === 0) {
             console.log(symbol)
             
            setResult(symbol)
            setTabChange(false)
            setKey(k)



            } 


    }




    document.title = 'رمز ارز دیجیتال بازی (Game) با لیست کامل '
    document.getElementsByTagName("META")[3].content= 'لیست کامل رمز ارز دیجیتال بازی Game از طریق بلاکچین کار می‌کند، جایی که تراکنش‌ها ثبت و تأیید می‌شوند. این فرآیند امنیت و شفافیت را برای تریدرها فراهم می‌آورد.'




    function hanldleSearch(event) {
        setSearch(event.target.value)

    }





    
    async function requestHakdleGetCoin() {
        await  axios.get('https://api.sinatether.com/Auth/CoinGet/').then((res)=>{



    if (res.status == 200)
    {
                   


                    const result_leve = res.data['pull'].filter(sym => sym.type === 'game')

                     setSymbol(result_leve)
                     setResult(result_leve)
                     if (flag == 0){
                         const ress = result_leve.sort(function (a, b) {
                             return b.changeRate - a.changeRate
                         }) 
                         setResult(ress)
                        setTabChange(true)
                        let k = Math.random()
                         setKey(k)
                         flag = flag + 1
                         console.log(flag)

                     }
                   
                     setIsLoading(false)


    }








  })


    }










        
var flag = 0
    

useEffect(()=>{


         const resultInterval = () => {
                 requestHakdleGetCoin()
                 setTimeout(resultInterval, 100000);



             };
         flag = 0
         resultInterval();
         setSearch('')




     },[])






    const onCopyText = () => {
        setIsCopied(true);
        toast.dismiss()
        
        toast.warning(' کپی شد!', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            });
};


var canonical = document.querySelector('link[rel="canonical"]');
if (canonical !== null) {
canonical.href = `https://sinatether.com/game-crypto-currencies-all-list`;
}


    useEffect(()=>{
        axios.get('https://api.sinatether.com/Auth/GetDetailsAccount',{withCredentials:true}).then((res)=>{
            if (res.status == 200){

                setAuth(true)
                setInviteLink(res.data['ref'])

            }
        }).catch((error)=>{

            setAuth(false)
        })
    },[])



    return(

        <div id="main-wrapper" className={"show"}>



            <LandHeader/>

            {isSmall? 


            <>
            <div className="gift2023">



                <div className="submobgif2023">



                <div className="justdhsdb24353535">


<img src="https://static.sinatether.com/images/game-icon.png" alt="رمز ارز دیجیتال بازی (Game) با لیست کامل "/>



</div>

                    <div className="jfsfs-242424">

                        <div>

                            <h1 className="h2-gift">

                                ارز های دیجیتال بازی
                                                                                  </h1>

                            <p className="pgift2023">
                            در دنیای مدرن، جایی که فناوری و سرگرمی به طور مداوم با هم ترکیب می‌شوند، رمز ارز دیجیتال بازی به عنوان یک نوآوری قدرتمند ظهور کرده است. 

                            </p>



                    

                        <button className="btn2j-gift" onClick={scrollToElement}>
                        مطالعه بیشتر 
                    </button>
               


                            

                            
                        </div>






                    </div>



                    


                </div>


                <div className=" items-sub-gift2023">


                
                <div className={'marginrl-14 '}>


                    <SliderTypes type={'game'}/>

                        

<div className={'DesktopMainPage mb-5 plr0'}>


<Tabs>
            <TabList >
            </TabList>

            <TabPanel>


                

                 <div className="accordion mt-4 ">
                     {isSmall?

                              <div className="text-center fdkshjfhgge24235">

                              <h5 className="tex-medf242">

                                ارزهای دیجیتال بازی
                              </h5>



                              </div>
                              :

                              <></>
                              }

                     <div className="row w-100 rsearch sdkjerywgrwrw2342">
                     <input className={'input-search text-large'} placeholder={' جستجو ارز دیجیتال'} onChange={hanldleSearch}/>

                     </div>

                     <div className={' pad-b12'}>
                                      
                                      {symbol ?

                                          <TabType handleTabs={handleTabs}/>
                                          :
                                          <></>
                                      }

                                  </div>



                                  {isLoading ?
                                      <>

                                      <LoadingAcc/>

                                          <LoadingAcc/>
                                      <LoadingAcc/>
                                          <LoadingAcc/>
                                      <LoadingAcc/>
                                      <LoadingAcc/>


                                      </>

                                      :


                                      <>



                     <div class="row py-2 margi-css354 "><div class="col-4 pl-4 text-large text-normal">نام</div><div class="col-4 text-center pl-0 text-large text-normal">
                         
                        قیمت جهانی
                       (تتر)

                         
                         </div><div class="col-4  text-large text-normal">تغییرات24h</div></div>




                      {
                          resultSym.length>0 && search != '' ?

                             resultSym.map((sym) =>

                             

                              <div className="accordion-item">
                                  <h2 className="accordion-header border-top py-1" id={`heading${sym['symbol']}`}>
                                      <button className="accordion-button pl-1 pr-0 pt-0 pb-0 collapsed" type="button"
                                              data-bs-toggle="collapse"
                                              data-bs-target={`#collapse${sym['symbol']}`}
                                              aria-expanded="true"
                                              aria-controls={`collapse${sym['symbol']}`}>

                                          <Link className="col-4 pointer linkStyle"
                                             to={`/${sym['symbol'].split('-')[0]}`}>
                                              <div className="text-black">
                                                  <img className="imgcoin "
                                                       src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
                                                  <span
                                                      className="spanHeaderAcc">  <span
                                                      className="ft-external-link text-large text-normal dis-grid">{sym['persionName']}


                                      <span
                                                          className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>
                                      </span>
                                                      
                                                      
                                                      
                                                      </span>
                             
                                              </div>
                                          </Link>


                                          <div
                                              className="col-4 pointer text-right text-blue-primery text-large priceTt"
                                          >{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(sym['sell'])}
                                              
                                              </div>
                                                  <div
                                              className="col-3 pointer text-right text-blue-primery text-large priceTt"
                                          >

                                          <span
                                              className={'text-medium priceTt'}>
                                              {sym['changeRate']>=0 ?
                                                  <>


                                                        <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                        <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                                        <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" stroke-width="1.333"/>
                                                        <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" stroke-width="1.333"/>
                                                      </svg>


                                              <span className={'text-success pl-1'}>
                                                  {sym['changeRate']}%

                                              </span>
                                                        </>

                                                  :

                                                  <>






                                          <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                            <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                            <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                            <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                          </svg>



                                              <span className={'text-danger pl-1'}>
                                                  {-1 * Number(sym['changeRate'])}%

                                              </span>


                                                  </>
                                              }
                                          </span>


                                          </div>


                                      </button>
                                  </h2>
                                  <div id={`collapse${sym['symbol']}`}
                                       className="accordion-collapse collapse "
                                       aria-labelledby={`heading${sym['symbol']}`}
                                       data-bs-parent="#accordionExample">
                                      <div className="accordion-body ">


                                          <ul className={'ul-custom'}>
                                              <li className={'col-6 pl-0 pr-0 '}>
                                                  <h6 data-inline-formset={true}
                                                      className={'col-12 text-success text-large text-normal '}>
                                                          
                                                          <div className="text-normal phyrfjshbf">خرید:</div> 
                                                      {new Intl.NumberFormat("fa").format(sym['BuyIrt'])}
                                                      <span className={' tomn242553'}>تومان</span>
                                                  </h6>
                         


                                              </li>

                                              <li className={'col-6 pr-0 pl-0'}>
                                                  <h6 data-inline-formset={true} className={'col-12 text-large text-danger text-normal content-left '}>
                                                      <div className="text-normal phyrfjshbf">
                                                          فروش:
                                                      </div>

                                                      {new Intl.NumberFormat("fa").format(sym['sellIrt'])}
                                                      <span className={' tomn242553'}>تومان</span>

                                                  </h6>
                                                

                                              </li>

                                          </ul>


                                          <div className="rowButton pt-3 pb-2 px-2 ">

                                              <div className="col-3 px-1 px---1">
                                              <Link to="/login">

                                                  <button
                                                      className="btn btn-success text-large w-100 py---5 buy mb-0 pointer ng-star-inserted btnsm">خرید
                                                  </button>
                                                  </Link>
                                              </div>
                                              <div className="col-3 px-1 px---1">
                                              <Link to="/login">

                                                  <button
                                                      className="btn btn-danger py---5 buy text-large w-100 mb-0 pointer ng-star-inserted btnsm">فروش
                                                  </button>
                                                  </Link>
                                              </div>

                                              <div className="col-3 px-1 px---1">
                                              <Link to="/login">


                                                  <button
                                                      className="btn btn-outline-success py---5 buy text-large w-100 pointer mb-0 btnsm text-success"
                                                      onClick={GoToLogin}>واریز
                                                  </button>
                                                  </Link>
                                              </div>

                                              <div className="col-3 px-1 px---1">
                                              <Link to="/login">

                                                  <button
                                                      className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm text-danger"
                                                      >برداشت
                                                  </button>
                                                  </Link>
                                              </div>
                                          </div>


                                      </div>
                                  </div>
                              </div>
                          )
                              :
                              <>







                              {result ?
                                  <PageItemsAcc key={key} itemsPerPage={15} items={result}/>
                                  :
                                  <PageItemsAcc key={key} itemsPerPage={15} items={symbol}/>


                              }
                              </>
                      }
                      </>
                          }
                 </div>
               



            </TabPanel>


        </Tabs>



  </div>


  </div>





                    

         

            <div ref={elementRef} className="  marginrl-14 hjfdsgbf24232" >



<SimpleAccordion data={data}/>
</div>

                </div>



            </div>


</>

:



<>
                    <div className="gift2023">



                        <div className="row marginrl-140">

                            <div className="col-6 jfsfs-25252">

                                <div>

                                    <h1 className="h2-gift">
                                    ارز های دیجیتال بازی
                                    </h1>

                                    <p className="hdfsbfsfonr123">
                                    در دنیای مدرن، جایی که فناوری و سرگرمی به طور مداوم با هم ترکیب می‌شوند، رمز ارز دیجیتال بازی به عنوان یک نوآوری قدرتمند ظهور کرده است.                                            <br/>
                                    این ارزهای دیجیتال، که اغلب به عنوان "GameFi" شناخته می‌شوند، نه تنها روش‌های پرداخت در دنیای بازی‌ها را متحول کرده‌اند، بلکه به بازیکنان امکان می‌دهند تا از طریق مشارکت فعال در اکوسیستم‌های بازی، درآمد کسب کنند.                                                                       
                                    </p>


                                    <button className="btn2j-gift" onClick={scrollToElement}>
                        مطالعه بیشتر 
                    </button>



                                    

                                    
                                </div>






                            </div>



                            <div className="col-6">


                                <img src="https://static.sinatether.com/images/game-icon.png" alt="ارزهای دیجیتال باز Game با لیست کامل"/>


                                
                            </div>


                        </div>



                        <div className=" marginrl-140 ">



                 

                        


                        










                    
                    <div className={'divcn w-100    plr0 pt-4 pb-4'}>

                    <SliderTypes type={'game'}/>


                        

                  <div className={'DesktopMainPage mb-5'}>





                      {isSmall ?

                          <Tabs>
                              <TabList >
                              </TabList>

                              <TabPanel>


                                  

                                   <div className="accordion mt-4 ">
                                       {isSmall?

                                                <div className="text-center fdkshjfhgge24235">

                                                <h5 className="tex-medf242">
                                                رمز ارز دیجیتال بازی (Game) با لیست کامل 
                              

                                                </h5>



                                                </div>
                                                :

                                                <></>
                                                }

                                       <div className="row w-100 rsearch sdkjerywgrwrw2342">
                                       <input className={'input-search text-large'} placeholder={' جستجو ارز دیجیتال'} onChange={hanldleSearch}/>

                                       </div>

                                       <div className={' pad-b12'}>
                                                        
                                                        {symbol ?

                                                            <TabType handleTabs={handleTabs}/>
                                                            :
                                                            <></>
                                                        }

                                                    </div>



                                                    {isLoading ?
                                                        <>

                                                        <LoadingAcc/>

                                                            <LoadingAcc/>
                                                        <LoadingAcc/>
                                                            <LoadingAcc/>
                                                        <LoadingAcc/>
                                                        <LoadingAcc/>


                                                        </>

                                                        :


                                                        <>



                                       <div class="row py-2 margi-css354 "><div class="col-4 pl-4 text-large text-normal">نام</div><div class="col-4 text-center pl-0 text-large text-normal">
                                           
                                          قیمت جهانی
                                         (تتر)

                                           
                                           </div><div class="col-4  text-large text-normal">تغییرات24h</div></div>




                                        {
                                            resultSym.length>0 && search != '' ?

                                               resultSym.map((sym) =>

                                               

                                                <div className="accordion-item">
                                                    <h2 className="accordion-header border-top py-1" id={`heading${sym['symbol']}`}>
                                                        <button className="accordion-button pl-1 pr-0 pt-0 pb-0 collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse${sym['symbol']}`}
                                                                aria-expanded="true"
                                                                aria-controls={`collapse${sym['symbol']}`}>

                                                            <Link className="col-4 pointer linkStyle"
                                                               to={`/${sym['symbol'].split('-')[0]}`}>
                                                                <div className="text-black">
                                                                    <img className="imgcoin "
                                                                         src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
                                                                    <span
                                                                        className="spanHeaderAcc">  <span
                                                                        className="ft-external-link text-large text-normal dis-grid">{sym['persionName']}


                                                        <span
                                                                            className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>
                                                        </span>
                                                                        
                                                                        
                                                                        
                                                                        </span>
                                               
                                                                </div>
                                                            </Link>


                                                            <div
                                                                className="col-4 pointer text-right text-blue-primery text-large priceTt"
                                                            >{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(sym['sell'])}
                                                                
                                                                </div>
                                                                    <div
                                                                className="col-3 pointer text-right text-blue-primery text-large priceTt"
                                                            >

                                                            <span
                                                                className={'text-medium priceTt'}>
                                                                {sym['changeRate']>=0 ?
                                                                    <>


                                                                          <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                                          <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                                                          <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" stroke-width="1.333"/>
                                                                          <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" stroke-width="1.333"/>
                                                                        </svg>


                                                                <span className={'text-success pl-1'}>
                                                                    {sym['changeRate']}%

                                                                </span>
                                                                          </>

                                                                    :

                                                                    <>






                                                            <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                              <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                                              <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                              <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                            </svg>



                                                                <span className={'text-danger pl-1'}>
                                                                    {-1 * Number(sym['changeRate'])}%

                                                                </span>


                                                                    </>
                                                                }
                                                            </span>


                                                            </div>


                                                        </button>
                                                    </h2>
                                                    <div id={`collapse${sym['symbol']}`}
                                                         className="accordion-collapse collapse "
                                                         aria-labelledby={`heading${sym['symbol']}`}
                                                         data-bs-parent="#accordionExample">
                                                        <div className="accordion-body ">


                                                            <ul className={'ul-custom'}>
                                                                <li className={'col-6 pl-0 pr-0 '}>
                                                                    <h6 data-inline-formset={true}
                                                                        className={'col-12 text-success text-large text-normal '}>
                                                                            
                                                                            <div className="text-normal phyrfjshbf">خرید:</div> 
                                                                        {new Intl.NumberFormat("fa").format(sym['BuyIrt'])}
                                                                        <span className={' tomn242553'}>تومان</span>
                                                                    </h6>
                                           


                                                                </li>

                                                                <li className={'col-6 pr-0 pl-0'}>
                                                                    <h6 data-inline-formset={true} className={'col-12 text-large text-danger text-normal content-left '}>
                                                                        <div className="text-normal phyrfjshbf">
                                                                            فروش:
                                                                        </div>

                                                                        {new Intl.NumberFormat("fa").format(sym['sellIrt'])}
                                                                        <span className={' tomn242553'}>تومان</span>

                                                                    </h6>
                                                                  

                                                                </li>

                                                            </ul>


                                                            <div className="rowButton pt-3 pb-2 px-2 ">

                                                                <div className="col-3 px-1 px---1">
                                                                <Link to="/login">

                                                                    <button
                                                                        className="btn btn-success text-large w-100 py---5 buy mb-0 pointer ng-star-inserted btnsm">خرید
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                <Link to="/login">

                                                                    <button
                                                                        className="btn btn-danger py---5 buy text-large w-100 mb-0 pointer ng-star-inserted btnsm">فروش
                                                                    </button>
                                                                    </Link>
                                                                </div>

                                                                <div className="col-3 px-1 px---1">
                                                                <Link to="/login">


                                                                    <button
                                                                        className="btn btn-outline-success py---5 buy text-large w-100 pointer mb-0 btnsm text-success"
                                                                        onClick={GoToLogin}>واریز
                                                                    </button>
                                                                    </Link>
                                                                </div>

                                                                <div className="col-3 px-1 px---1">
                                                                <Link to="/login">

                                                                    <button
                                                                        className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm text-danger"
                                                                        >برداشت
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                                :
                                                <>



                                                
                                   <div className="accordion-item">
                                                    <h2 className="accordion-header border-top py-1" id={`headingUSDT`}>
                                                        <button className="accordion-button  pl-1 pr-0 pt-0 pb-0 " type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapseUSDT`}
                                                                aria-expanded="true"
                                                                aria-controls={`collapseUSDT`}>

                                                            <Link className="col-6 pointer linkStyle text-white"
                                                               to={`/USDT`}>
                                                                <div className="text-black">
                                                                    <img className="imgcoin "
                                                                         src={`https://sinatether.com/CoinsImg/USDT.png`} alt={""}/>
                                                                    <span
                                                                        className="spanHeaderAcc">  <span
                                                                        className="ft-external-link text-large text-normal dis-grid">تـتر
                                                                        
                                                                        <span
                                                                        className="text-medium text-muted">USDT</span>
                                                                        </span>
                                                                        
                                                                        </span>
                                                
                                                                </div>
                                                            </Link>


                                                            <div
                                                                className="col-5 pointer text-right text-blue-primery text-large priceTt"
                                                            > <span
                                                                className={'text-medium priceTt'}></span></div>


                                                        </button>
                                                    </h2>
                                                    <div id={`collapseUSDT`}
                                                         className="accordion-collapse collapse show "
                                                         aria-labelledby={`headingUSDT`}
                                                         data-bs-parent="#accordionExample">
                                                        <div className="accordion-body ">


                                                            <ul className={'ul-custom'}>
                                                                <li className={'col-6 pl-0 pr-0'}>
                                                                    <h6 data-inline-formset={true}
                                                                        className={'col-12 text-success text-large text-normal'}>
                                                                            <div className="text-normal phyrfjshbf">
                                                                            خرید:
                                                                    

                                                                            </div>
                                                                            
                                                                        
                                                                        {new Intl.NumberFormat("fa").format(TeterPriceBuy)}
                                                                        <span className={' tomn242553'}>تومان</span>
                                                                    </h6>
                                                                


                                                                </li>

                                                                <li className={'col-6 pl-0 pr-0"'}>
                                                                    <h6 data-inline-formset={true} className={'col-12 text-large text-danger text-normal content-left '}>

                                                                        <div className="text-normal phyrfjshbf">
                                                                            فروش:

                                                                        </div>



                                                                        {new Intl.NumberFormat("fa").format( TeterPriceSell)}
                                                                        <span className={' tomn242553'}>تومان</span>

                                                                    </h6>

                                                                </li>

                                                            </ul>


                                                            <div className="rowButton pt-1 pb-1 px-2 ">

                                                                
                                                                <div className="col-3 px-1 px---1">
                                                                <Link to={"/login"}>

                                                                    <button
                                                                        className="btn btn-success text-large w-100 py---5 buy mb-0 pointer ng-star-inserted btnsm">خرید
                                                                    </button>
                                                                    </Link>

                                                                </div>

                                                                <div className="col-3 px-1 px---1">
                                                                <Link to={"/login"}>

                                                                    <button
                                                                        className="btn btn-danger py---5 buy text-large w-100 mb-0 pointer ng-star-inserted btnsm">فروش
                                                                    </button>
                                                                    </Link>
                                                                </div>

                                                                <div className="col-3 px-1 px---1">
                                                                <Link to={"/login"}>

                                                                    <button
                                                                        className="btn btn-outline-success py---5 buy text-large w-100 pointer mb-0 btnsm text-success"
                                                                        >واریز
                                                                    </button>
                                                                    </Link>
                                                                </div>

                                                                <div className="col-3 px-1 px---1">
                                                                <Link to={"/login"}>

                                                                    <button
                                                                        className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm text-danger"
                                                                        >برداشت
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                                




                                                {result ?
                                                    <PageItemsAcc key={key} itemsPerPage={25} items={result}/>
                                                    :
                                                    <PageItemsAcc key={key} itemsPerPage={25} items={symbol}/>


                                                }
                                                </>
                                        }
                                        </>
                                            }
                                   </div>
                                 



                              </TabPanel>


                          </Tabs>
                          :

                          <>


                          <Tabs>
                              <TabList>
                              </TabList>


                              <TabPanel>
                                  <table className="table table68 row table-cusj3424 table68 row plr-32">
                                      


                                     


                                          <>

                                          <div className="text-center fdkshjfhgge24235"><h5 className="tex-medf242">                                                     ارزهای دیجیتال بازی 
</h5></div>

                                         
                          <div className="row    w-100 pl-0 pr-0 ">

<div className="col-6 pl-0 pr-0 ">

<div className={'pr-0 pl-0'}>
                                <TabType handleTabs={handleTabs}/>

                            </div>

</div>
<div className="col-6 text-left pt-1">
<div className={'search13242 '}>
<input className={'input-search text-large pr-4'} placeholder={'  جستجو ارز دیجیتال'} onChange={hanldleSearch}/>
</div>

</div>





</div>

                                         

                                              <div className={'row  mborder w-100 pl-1 pb-2 pt24'}>
                                                  <div className={'col-2 pt-2 '}>
                                                      <span className={'text-normal text-dark'}>نام</span>


                                                  </div>


                                                  <div className={'col-2  pt-2 pb-0'}>
                                                      <span className={'text-normal text-dark'}>خرید</span>


                                                  </div>


                                                  <div className={'col-2  pt-2 pb-0'}>
                                     <span className={'text-normal text-dark'}>
                                               فروش

                                     </span>


                                                  </div>


                                                  <div className={'col-2 pt-2 pb-0'}>
                                                      <span className={'text-normal text-dark'}>قیمت جهانی</span>


                                                  </div>

                                                  
                                                  <div className={'col-2 pt-2 pb-0'}>
                                                      <span className={'text-normal text-dark'}> تغییرات 24h</span>


                                                  </div>


                                                  <div className={'col-2 pt-2 pb-0'}>
                                                      <span className={'text-normal text-muted'}></span>


                                                  </div>

                                              </div>


                                              <tbody>

                                              {isLoading ?
                                                                <>

                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>

                                                                </>


                                                :

                                                <>

                                             



                                            { resultSym.length>0 && search != '' ?

                                            resultSym.map((sym)=>(
                                                                            
                                                    <div className={'row tr_row  py-2 px-1 '}>
                                                    <div className={'col-2 '}>
                                                        <Link className="pointer linkStyle"
                                                        to={`/${sym['symbol'].split('-')[0]}`}>
                                                            <div className="text-black">
                                                                <img className="imgcoin "
                                                                    src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
                                                                <span
                                                                    className="spanHeaderAcc">
                                                    <span
                                                    className="ft-external-link tt0562 text-large">{sym['persionName']}


                                                   <span className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>

                                                    
                                                    
                                                    
                                                    
                                                    </span>

                                                    </span>

                                                            </div>
                                                        </Link>


                                                    </div>
                                                    {sym ?
                                                        <>

                                                            <div className={'col-2 '}>
                                                                <div className={' table-hover'}>
                                                                    <p className={'mb-0 m0562 text-success'}>{new Intl.NumberFormat("fa").format(sym['BuyIrt'])} </p>
                                                                </div>

                                                            </div>
                                                            <div className={'col-2 '}>
                                                                <div className={' table-hover'}>
                                                                    <p className={'mb-0 m0562 text-danger'}> {new Intl.NumberFormat("fa").format(sym['sellIrt'])} </p>
                                                                </div>
                                                            </div>
                                                            <div className={'col-2 '}>
                                                                <div className={'table-hover'}>
                                                                    <p className={'mb-0 m0562 priceTt'}> {new Intl.NumberFormat("fa").format(sym['sell'])}</p>
                                                                </div>
                                                            </div>


                                                            <div class="col-2 pointer text-right text-blue-primery text-large priceTt">
                                                                <p className={'text-medium priceTt mb-0 m0562 pt-1'}>
                                                                {sym['changeRate']>=0 ?
                                                                    <>


                                                                          <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                                          <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                                                          <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" stroke-width="1.333"/>
                                                                          <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" stroke-width="1.333"/>
                                                                        </svg>


                                                                <span className={'text-success pl-1'}>
                                                                    {sym['changeRate']}%

                                                                </span>
                                                                          </>

                                                                    :

                                                                    <>






                                                            <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                              <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                                              <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                              <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                            </svg>



                                                                <span className={'text-danger pl-1'}>
                                                                    {-1 * Number(sym['changeRate'])}%

                                                                </span>


                                                                    </>
                                                                }
                                                            </p>



        </div>

                                                        </>
                                                        :
                                                        <>



                                                        </>


                                                    }


                                                    <div className={'col-2 text-left  '}>

                                                        <div
                                                            className=" float-left text-right  px-2 ">

                                                            <div className="col-3 px-1 px---1 btn-size btnnSi">
                                                                <Link to={`/${sym['symbol'].split('-')[0]}`}>

                                                                    <button
                                                                        className="btn btn-primary text-large w-100 py---6 buy mb-0 pointer ng-star-inserted btn-size ">
                                                                        <span className={'text-large text-white pr-1 pt-1 pb-1'}>خرید</span>
                                                                        <span className={'text-large text-white-50'}>|</span>
                                                                        <span className={'text-large text-white pl-1'}>
                                                                            فروش
                                                                        </span>
                                                                    </button>

                                                                </Link>

                                                            </div>



                                                        </div>


                                                    </div>

                                                    </div>

                                            ))
                                                  


                                                  :


                                                      <>




<>


                                                <PaginatedItems key={key}  itemsPerPage={15}
                                                                items={result}/>



                                                </>
                                                      </>
                                                  
                                              }

                                              </>



                      }





                                              

                                              </tbody>

                                          </>

                                      
                                  </table>
                              </TabPanel>
                              
                          </Tabs>
                          </>
                      }






                      </div>


                </div>

                </div>






                <div ref={elementRef} className=" marginrl-140 hjfdsgbf24232">



<SimpleAccordion data={data}/>
</div>



                    </div>































     

                    <div className="just-center  ">

                    <div className="lastttx">
                    با سینا تتر پازل سرمایه گذاری تو کامل کن !

                    </div>

                    <div className="mdfhsyfsf354 ">

                    <Link to={'/login'}>

                    <button className="btn btnsjhrsrbr35">
                    همین الان ثبت نام کن !
                    </button>

                    </Link>

                    </div>
                    </div>

</>

            }


            


            <Footer/>

            



        
        
        </div>
    )
}